import { ReactNode } from 'react';
import ReactTooltip from 'react-tooltip';
import styled from 'styled-components';
import { colors } from '../../styles/GlobalStyles';
import { Icon, IconInfo, InfoSmallIcon } from '../../styles/Icons';
import { Flexed } from '../../styles/GlobalComponents';

const WrapperStyled = styled.div<{ margin?: string }>`
  margin: ${({ margin }) => (margin ? margin : '12px 0')};
  display: inline;
`;

export const TextWithTooltip = ({
  children,
  tooltip,
  margin,
  width = '200px',
  link,
  center,
  color,
  textColor,
  disabled
}: {
  children?: ReactNode;
  tooltip: ReactNode;
  margin?: string;
  width?: string;
  link?: boolean;
  center?: boolean;
  color?: string;
  textColor?: string;
  disabled?: any;
}) => {
  const id = Math.random().toString();

  return (
    <WrapperStyled margin={margin} data-tip data-for={id}>
      {children}

      {tooltip && (
        // <Icon >
        <span style={{ display: 'inline', marginLeft: 4 }}>
          <InfoSmallIcon disabled={disabled} />
        </span>
        // </Icon>
      )}

      <ReactTooltip
        id={id}
        place='top'
        effect='solid'
        backgroundColor={color ? color : '#fff'}
        textColor={textColor ? textColor : colors.neutral900}>
        {center ? (
          <Flexed justifyCenter width={width}>
            {tooltip}
          </Flexed>
        ) : (
          <Flexed width={width}>{tooltip}</Flexed>
        )}
      </ReactTooltip>
    </WrapperStyled>
  );
};
